export const GROW_GUIDE_FREE_ID = 'grow-guide-free';
export const GROW_GUIDE_TIERS = {
  FREE: 'free',
  PRO: 'pro'
};